import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from "./Spinner";
import { CheckIcon } from "@heroicons/react/solid";
import { Faded } from "baby-i-am-faded";
import classNames from "classnames";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import NProgress from "nprogress";
import React, { useEffect, useMemo, useState } from "react";
import "../global";
import toast from "react-hot-toast";
import { Link } from "./Link";
import { useThrowingFn } from "../utils";
import { PageContainer } from "./PageContainer";
// const getSubscriptionMemoized = memoize(getSubscription, { isPromise: true })
export function Pricing(_param) {
    var refetchSubscription = function refetchSubscription() {
        setSubscription(undefined);
        getSubscription().then(function(subscription) {
            if (subscription) {
                setSubscription(subscription);
            }
        });
    };
    var products = _param.products, _animate = _param.animate, animate = _animate === void 0 ? false : _animate, _className = _param.className, className = _className === void 0 ? "" : _className, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, onCheckout = _param.onCheckout, _promptLogin = _param.promptLogin, promptLogin = _promptLogin === void 0 ? function() {} : _promptLogin, updatePlan = _param.updatePlan, getSubscription = _param.getSubscription, productDetails = _param.productDetails, needMoreEmail = _param.needMoreEmail, manageSubscriptionHref = _param.manageSubscriptionHref, _pricesCurrency = _param.pricesCurrency, pricesCurrency = _pricesCurrency === void 0 ? "USD" : _pricesCurrency, _allowYearlyBilling = _param.allowYearlyBilling, allowYearlyBilling = _allowYearlyBilling === void 0 ? true : _allowYearlyBilling, passthrough = _param.passthrough, rest = _object_without_properties(_param, [
        "products",
        "animate",
        "className",
        "isLoading",
        "onCheckout",
        "promptLogin",
        "updatePlan",
        "getSubscription",
        "productDetails",
        "needMoreEmail",
        "manageSubscriptionHref",
        "pricesCurrency",
        "allowYearlyBilling",
        "passthrough"
    ]);
    var ref = useState(), subscription = ref[0], setSubscription = ref[1];
    var ref1 = useSession(), status = ref1.status, session = ref1.data;
    var ref2 = useState("month"), billingInterval = ref2[0], setBillingInterval = ref2[1];
    useEffect(function() {
        void _async_to_generator(function() {
            var subscription;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (status !== "authenticated") {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            getSubscription()
                        ];
                    case 1:
                        subscription = _state.sent();
                        if (subscription) {
                            setSubscription(subscription);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        status
    ]);
    var FadedComponent = animate ? Faded : "div";
    return /*#__PURE__*/ _jsxs(PageContainer, _object_spread_props(_object_spread({
        id: "pricing",
        style: {
            // @ts-ignore
            "--page-max-width": "100vw"
        },
        className: classNames("relative self-center mx-auto", className)
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "relative sm:flex sm:flex-col sm:align-center",
                children: allowYearlyBilling && /*#__PURE__*/ _jsx(BillingIntervalSelect, {
                    billingInterval: billingInterval,
                    setBillingInterval: setBillingInterval
                })
            }),
            /*#__PURE__*/ _jsxs(FadedComponent, _object_spread_props(_object_spread({}, animate && {
                cascade: true,
                whenInView: true,
                triggerOnce: true
            }), {
                style: {
                    minHeight: "500px"
                },
                className: classNames("relative flex flex-col items-center justify-center", "mt-12 space-y-8 lg:mx-auto lg:items-stretch", "lg:flex-row lg:space-x-6 lg:space-y-0"),
                children: [
                    isLoading && /*#__PURE__*/ _jsx(Spinner, {}),
                    !isLoading && products && products.sort(function(a, b) {
                        var ref, ref1, ref2, ref3;
                        return ((ref1 = a === null || a === void 0 ? void 0 : (ref = a.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
                            return one.currency === pricesCurrency;
                        })) === null || ref1 === void 0 ? void 0 : ref1.unitAmount) - ((ref3 = b === null || b === void 0 ? void 0 : (ref2 = b.prices) === null || ref2 === void 0 ? void 0 : ref2.find(function(one) {
                            return one.currency === pricesCurrency;
                        })) === null || ref3 === void 0 ? void 0 : ref3.unitAmount);
                    }).filter(function(x) {
                        if (status === "authenticated") {
                            return x.prices.every(function(p) {
                                return p.unitAmount > 0;
                            });
                        }
                        return true;
                    }).map(function(product) {
                        var ref;
                        var price = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
                            return one.currency === pricesCurrency;
                        });
                        if (!price) {
                            return null;
                        }
                        if (product.billing_type !== billingInterval) {
                            return null;
                        }
                        var details = productDetails.find(function(x) {
                            return x.paddleId === product.paddleId;
                        });
                        return /*#__PURE__*/ _jsx(SubscriptionPlan, {
                            passthrough: passthrough,
                            description: details === null || details === void 0 ? void 0 : details.description,
                            updatePlan: updatePlan,
                            refetchSubscription: refetchSubscription,
                            promptLogin: promptLogin,
                            features: (details === null || details === void 0 ? void 0 : details.features) || [],
                            contactUs: details === null || details === void 0 ? void 0 : details.contactLink,
                            onCheckout: onCheckout,
                            product: product,
                            price: price,
                            subscription: subscription
                        }, product.paddleId);
                    })
                ]
            })),
            subscription && manageSubscriptionHref ? /*#__PURE__*/ _jsx(FadedComponent, {
                className: "text-center h-[2em] mt-10",
                children: /*#__PURE__*/ _jsx(Link, {
                    href: manageSubscriptionHref,
                    children: "Manage subscription"
                })
            }) : !!needMoreEmail && /*#__PURE__*/ _jsxs(FadedComponent, {
                className: "text-center opacity-80 text-sm h-[2em] mt-10",
                children: [
                    "Need more?",
                    " ",
                    /*#__PURE__*/ _jsx(Link, {
                        href: "mailto:".concat(needMoreEmail, "?subject=").concat(encodeURIComponent("Need a custom plan")),
                        children: "Contact me"
                    })
                ]
            })
        ]
    }));
}
function BillingIntervalSelect(param) {
    var billingInterval = param.billingInterval, setBillingInterval = param.setBillingInterval;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("relative self-center bg-gray-200 rounded-lg", "p-0.5 flex"),
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return setBillingInterval("month");
                },
                type: "button",
                className: classNames("relative w-1/2 py-2 text-sm font-medium text-gray-700", "whitespace-nowrap rounded-lg sm:px-8 sm:w-auto", "focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "month",
                    "bg-transparent": billingInterval !== "month"
                }),
                children: "Monthly billing"
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return setBillingInterval("year");
                },
                type: "button",
                className: classNames("relative w-1/2 bg-white py-2 text-sm font-medium", "text-gray-700 whitespace-nowrap rounded-lg", "sm:px-8 sm:w-auto focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "year",
                    "bg-transparent": billingInterval !== "year"
                }),
                children: "Yearly billing"
            })
        ]
    });
}
function SubscriptionPlan(param) {
    var product = param.product, price = param.price, subscription = param.subscription, description = param.description, refetchSubscription = param.refetchSubscription, onCheckout = param.onCheckout, _contactUs = param.contactUs, contactUs = _contactUs === void 0 ? "" : _contactUs, features = param.features, promptLogin = param.promptLogin, updatePlan = param.updatePlan, style = param.style, passthrough = param.passthrough;
    var ref;
    var router = useRouter();
    var ref1 = useSession(), status = ref1.status, session = ref1.data;
    var ref2 = useThrowingFn({
        fn: updatePlan,
        errorMessage: "Failed to update plan",
        successMessage: "Updated plan!"
    }), changePlan = ref2.fn, isLoading = ref2.isLoading;
    var handlePricingClick = function() {
        var _ref = _async_to_generator(function(paddleId) {
            var ref, pass, ref1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (status !== "authenticated" && promptLogin) {
                            return [
                                2,
                                promptLogin()
                            ];
                        }
                        if (!(session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id)) {
                            throw new Error("User ID is missing");
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            7,
                            8
                        ]);
                        if (!subscription) return [
                            3,
                            5
                        ];
                        // clear subscription cache
                        // getSubscriptionMemoized.cache.keys.length = 0
                        // getSubscriptionMemoized.cache.values.length = 0
                        if (!confirm("Changing plan will remove any existing coupons, continue?")) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            changePlan({
                                subscriptionId: subscription.paddleSubscriptionId,
                                planId: paddleId
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 100);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            refetchSubscription()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        NProgress.start();
                        pass = passthrough();
                        Paddle.Checkout.open({
                            product: paddleId,
                            email: session.user.email,
                            passthrough: typeof pass === "string" ? pass : JSON.stringify(pass),
                            successCallback: function() {
                                toast.success("Created plan", {
                                    position: "top-center"
                                });
                                refetchSubscription();
                            }
                        });
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        if (onCheckout) {
                            ;
                            onCheckout({
                                isChangePlan: Boolean(subscription),
                                userId: session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.id
                            });
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePricingClick(paddleId) {
            return _ref.apply(this, arguments);
        };
    }();
    var alreadyUsingThisPlan = product.paddleId === (subscription === null || subscription === void 0 ? void 0 : subscription.productId);
    var buyMessage = useMemo(function() {
        if (price.unitAmount == 0) {
            return "Get started";
        }
        if (alreadyUsingThisPlan) {
            return "Current plan";
        }
        if (subscription) {
            if (price.unitAmount > Number(subscription.unit_price) * 100) {
                return "Upgrade";
            }
            return "Downgrade";
        }
        if (!!product.trial_days) {
            return "Start free trial";
        }
        return "Buy ".concat(product.name);
    }, [
        subscription,
        price
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        style: style,
        className: classNames("border border-gray-200 rounded-lg shadow-sm", "divide-y divide-gray-200 bg-white max-w-sm w-[280px] xl:w-[310px]"),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "p-6 flex flex-col h-[300px]",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-lg font-medium leading-6 text-gray-900",
                        children: (ref = product.name) === null || ref === void 0 ? void 0 : ref.split("-")[0]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "h-12 mt-4 text-sm font-medium tracking-wide text-gray-500",
                        children: description || "."
                    }),
                    contactUs ? /*#__PURE__*/ _jsx("p", {
                        className: "mt-9 text-center text-lg text-gray-500"
                    }) : /*#__PURE__*/ _jsxs("p", {
                        className: "mt-8",
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                className: "text-4xl font-extrabold tracking-wide text-gray-900",
                                children: [
                                    "$",
                                    Number(// if billing_type is year, divide the price by 12
                                    product.billing_type === "year" ? price.unitAmount / 12 / 100 : price.unitAmount / 100).toFixed(0)
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-base font-medium text-gray-500",
                                children: "/mo"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-1"
                    }),
                    contactUs ? /*#__PURE__*/ _jsx(BuyButton, {
                        children: /*#__PURE__*/ _jsx("a", {
                            href: contactUs,
                            children: "Contact"
                        })
                    }) : /*#__PURE__*/ _jsx(BuyButton, {
                        onClick: function() {
                            price.unitAmount == 0 ? promptLogin() : handlePricingClick(product.paddleId);
                        },
                        "aria-label": "buy ".concat(product.name),
                        disabled: alreadyUsingThisPlan,
                        children: isLoading ? "Loading..." : buyMessage
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames("text-xs text-center mt-3 font-medium text-gray-500", "min-h-[1.2em]"),
                        children: !!product.trial_days && /*#__PURE__*/ _jsxs("span", {
                            className: "",
                            children: [
                                product.trial_days,
                                " days free trial"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "px-6 pt-6 pb-8",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: classNames("text-sm font-medium tracking-wide text-gray-400", "uppercase"),
                        children: "What's included"
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        role: "list",
                        className: "mt-6 space-y-4 text-sm font-medium",
                        children: features.map(function(feature) {
                            return /*#__PURE__*/ _jsxs("li", {
                                className: "flex space-x-3",
                                children: [
                                    /*#__PURE__*/ _jsx(CheckIcon, {
                                        className: "flex-shrink-0 w-5 h-5 text-emerald-600",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-gray-600 ",
                                        children: feature
                                    })
                                ]
                            }, feature);
                        })
                    })
                ]
            })
        ]
    });
}
function BuyButton(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = _object_without_properties(_param, [
        "children",
        "disabled"
    ]);
    return /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
        // variant='unstyled'
        className: classNames("block w-full py-2 mt-8 text-sm font-semibold text-center", "text-white bg-gray-900 border border-black rounded-md", "hover:cursor-pointer active:bg-white active:text-black", disabled ? "opacity-50 pointer-events-none" : "")
    }, rest), {
        children: children
    }));
}
